import { Component } from './component';

export interface SliderProps {
  min: number;
  max: number;
  step?: number;
  value?: number;
  vertical?: boolean;
  boxIndicator?: boolean;
  onChange?: (value: number) => void;
}

export class Slider extends Component {
  public el: HTMLInputElement | HTMLDivElement;
  private slider: HTMLInputElement;

  constructor(props: SliderProps) {
    super();

    this.slider = document.createElement('input');
    this.slider.setAttribute('type', 'range');
    this.slider.setAttribute('min', props.min.toString());
    this.slider.setAttribute('max', props.max.toString());

    if (props.step) {
      this.slider.setAttribute('step', props.step.toString());
    }

    if (props.value) {
      this.slider.value = props.value.toString();
    }

    if (props.boxIndicator) {
      this.slider.classList.add('has-box-indicator');
    }

    this.slider.addEventListener('input', () => {
      if (props.onChange) {
        props.onChange(parseFloat(this.slider.value));
      }
    });

    if (props.vertical) {
      this.el = document.createElement('div');
      this.el.classList.add('is-vertical');
      this.el.appendChild(this.slider);
    } else {
      this.el = this.slider;
    }
  }

  getValue(): number {
    return parseFloat(this.slider.value);
  }

  setValue(value: number) {
    this.slider.value = value.toString();
  }
}
